const Rojito = ({ isActiveWomensMode }) => {
    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' className='FrontPage--Riddle__Screen__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg' className='FrontPage--Riddle__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                <img src='/img/page/xolos-five.png' className='FrontPage--Riddle__Screen__Container__Logo' />

                {/* <p className="FrontPage--Riddle__Screen__Container__Title" style={{ fontFamily: '"GFS Didot", serif' }}>¡Glup Glup!</p> */}
                {/* <p className="FrontPage--Riddle__Screen__Container__Subtitle text-center mt-5 fs-1" style={{ fontFamily: '"GFS Didot", serif' }}>presentada por</p> */}
                <p className="FrontPage--Riddle__Screen__Container__Title">¡Glup Glup!</p>
                <p className="FrontPage--Riddle__Screen__Container__Subtitle text-center mt-5 fs-1">presentada por</p>
                <img src="/img/games/balloons/male/january-31-2026/Interaktia-Dinamicas-Digitales-Eventos-Deportivos-Rojito-Drinks.png" className="FrontPage--Riddle__Screen__Container__BrandLogo mt-5" />
            </div>
            
            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { Rojito };